/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Properties_Bulk_Transfer_DoneInputs */

const cs_properties_bulk_transfer_done = /** @type {(inputs: Properties_Bulk_Transfer_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Převedeno ${i?.count} nemovitostí`)
};

const en_properties_bulk_transfer_done = /** @type {(inputs: Properties_Bulk_Transfer_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Transferred ${i?.count} listings`)
};

/**
* | output |
* | --- |
* | "Transferred {count} listings" |
*
* @param {Properties_Bulk_Transfer_DoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const properties_bulk_transfer_done = /** @type {((inputs: Properties_Bulk_Transfer_DoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Properties_Bulk_Transfer_DoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_properties_bulk_transfer_done(inputs)
	return cs_properties_bulk_transfer_done(inputs)
});